import { useNavigate } from "react-router-dom"
import { Button } from "../../../components/ui/button"
import useBreakpoint from "../../../hooks/useBreakpoint"
import Col from "../../ui/layouts/column"
import { Separator } from "../../ui/separator"
import MerchantRow, { MerchantProps } from "./MerchantRow"

export const merchants: MerchantProps[] = [
	{
		name: "Inpro",
		description: "Accesorios para escritorio",
		type: "Ecommerce",
		address: "Irala 231, CABA, Argentina",
		web_url: "https://inpro.ar/",
		ig_url: "https://www.instagram.com/inpro.la",
		logo_url: "https://inpro.ar/_next/static/media/logo.952518ca.svg",
		cover_url:
			"https://inpro.ar/_next/image?url=https%3A%2F%2Facdn.mitiendanube.com%2Fstores%2F001%2F940%2F891%2Fproducts%2Fipr-005_sd-pro_lifestyle-1-6f0c6b85f86527143d17261620699381-1024-1024.jpg&w=2048&q=75&dpl=dpl_HWHv8WiJjEwscM9JerF5oz82niZ6",
	},
	{
		name: "Ganga Home",
		description: "Decoración para el hogar",
		type: "Ecommerce",
		address: "Norcenter Local 20 - Munro - Buenos Aires",
		web_url: "https://www.gangahome.com.ar/",
		ig_url: "https://www.instagram.com/ganga.home",
		logo_url:
			"data:image/png;base64,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",
		cover_url:
			"https://d3ugyf2ht6aenh.cloudfront.net/stores/001/487/825/products/f8e1b6f7-9551-4277-90e4-f2fb014cb68f1-0d97e2d5bcee284a2616949110578020-1024-1024.webp",
	},
	{
		name: "Fábrica de Fotolibros",
		description: "Fotolibros",
		logo_url: "/home/merchants/fdf.png",
		ig_url: "https://www.instagram.com/fabricadefotolibros/",
		web_url: "https://fabricadefotolibros.com",
		cover_url: "/home/merchants/covers/fdf_cover.png",
		address: "Concepción Arenal 4501, Chacarita",
		type: "Ecommerce",
	},
	{
		name: "Odin Hood",
		description: "Ropa y hoodies",
		logo_url: "/home/merchants/odinhood.png",
		ig_url: "https://www.instagram.com/odin.hood/",
		web_url: "https://odinhood.com",
		cover_url: "/home/merchants/covers/odinhood_cover.png",
		address: "Buenos Aires",
		type: "Ecommerce",
	},
	{
		name: "TecnoImport",
		description: "Tecnología, Logistica internacional",
		logo_url:
			"https://i.pinimg.com/564x/71/a6/c9/71a6c9c9cecf61197cd474a4a5ba3bb9.jpg",
		ig_url: "https://www.instagram.com/tecnoimportbs/",
		web_url: "https://tecnoimportbs.com/",
		cover_url:
			"https://www.apple.com/v/macbook-pro-14-and-16/e/images/overview/hero/hero_intro_endframe__e6khcva4hkeq_large.jpg",
		address: "Palermo, Puerto Madero, Buenos Aires",
		type: "Ecommerce",
	},
	{
		name: "Hypestyle",
		description: "Ropa streetwear",
		logo_url: "/home/merchants/hypestyle.png",
		ig_url: "https://www.instagram.com/hypestylearg/",
		web_url: "https://hypestyle.com.ar",
		cover_url: "/home/merchants/covers/hypestyle_cover.png",
		address: "Buenos Aires",
		type: "Ecommerce",
	},
	{
		name: "Arque",
		description: "Muebles de madera",
		logo_url: "/home/merchants/arque.png",
		ig_url: "https://www.instagram.com/arque.home/",
		web_url: "https://arque.mitiendanube.com/",
		cover_url: "/home/merchants/covers/arque_cover.png",
		address: "Arcos 4763, Nuñez, CABA",
		type: "Ecommerce",
	},

	{
		name: "Tuki Travel",
		description: "Viajes",
		logo_url:
			"https://tukitravel.com.ar/wp-content/uploads/2023/10/cropped-cropped-tuki-colores-2-1-300x300.png",
		ig_url: "https://www.instagram.com/tukiarg",
		web_url: "https://tukitravel.com.ar",
		cover_url:
			"https://tukitravel.com.ar/wp-content/uploads/2023/11/woman-beach-jump-332278.jpg",
		address: "Buenos Aires",
		type: "Ecommerce",
	},
	{
		name: "TiendaCry",
		description: "Ropa Streetwear",
		logo_url: "/home/merchants/tiendacry.png",
		ig_url: "https://www.instagram.com/tiendacry",
		web_url: "https://tiendacry.com.ar/",
		cover_url: "/home/merchants/covers/tiendacry_cover.png",
		address: "Obispo Oro 479 PB B",
		type: "Ecommerce",
	},
	{
		name: "Indochina",
		description: "Ropa",
		logo_url: "/home/merchants/indochina.png",
		ig_url: "https://www.instagram.com/indochina.designs",
		web_url: "https://www.indochinadesigns.com.ar/",
		backgroundColor: "#000000",
		cover_url: "/home/merchants/covers/indochina_cover.png",
		address: "Defensa 1066, San Telmo",
		type: "Ecommerce",
	},
	{
		name: "Carpe Noctem",
		description: "Streetwear",
		logo_url: "/home/merchants/carpenoctem.png",
		ig_url: "https://www.instagram.com/carpenoctem.club",
		web_url: "https://carpenoctem.club/",
		cover_url: "/home/merchants/covers/carpenoctem_cover.png",
		address: "Concord Pilar Neo Suites, Departamento Cristal 1106",
		type: "Ecommerce",
	},
	{
		name: "Börd",
		description: "Accesorios deco",
		type: "Ecommerce",
		logo_url: "/home/merchants/bord.png",
		cover_url: "/home/merchants/covers/bord_cover.png",
		address: "Depósito en Paternal",
		web_url: "https://bord.com.ar",
		ig_url: "https://www.instagram.com/bord.deco/",
	},
	{
		name: "Brownie Planet",
		description: "Cookies y Brownies",
		type: "Establecimiento",
		logo_url: "/home/merchants/bp.png",
		cover_url: "/home/merchants/covers/bp_cover.png",
		address: "Darragueyra 2191, Palermo",
		web_url: "https://palermo.brownieplanet.com/",
		ig_url: "https://www.instagram.com/brownieplanet.arg/",
	},
	{
		name: "Liberty 31",
		description: "Café Resto Bar",
		type: "Establecimiento",
		address: "Rodolfo Walsh 110, Retiro",
		logo_url: "/home/merchants/liberty31.png",
		cover_url: "/home/merchants/covers/liberty31_cover.png",
		web_url: "https://goo.gl/maps/C5SM758XPtwDXBZD9",
		ig_url: "https://www.instagram.com/liberty31retiro/",
	},
	{
		name: "Masa Termica",
		description: "Construcción",
		type: "Ecommerce",
		address: "El Bolsón, Río Negro, Argentina",
		logo_url:
			"https://i0.wp.com/masatermica.online/blog/wp-content/uploads/2021/07/cropped-LogoBl.png?w=512&ssl=1",
		cover_url:
			"https://i0.wp.com/masatermica.online/blog/wp-content/uploads/2022/04/IMG_20221027_122752379.jpg?w=1037&ssl=1",
		web_url: "https://masatermica.com",
		ig_url: "https://instagram.com/masa.termica",
	},
	{
		name: "Argentina Market",
		description: "Mercado Regional Gourmet",
		type: "Establecimiento",
		address: "Ladislao Martinez 172",
		logo_url: "/home/merchants/market.png",
		cover_url: "/home/merchants/covers/market_cover.png",
		web_url: "https://argentinamarket.com.ar/",
		ig_url: "https://www.instagram.com/argentinamarket/",
	},
	{
		name: "San Francisco",
		description: "Fiambrería",
		type: "Establecimiento",
		address: "Av. Urquiza 75, Chivilcoy, Buenos Aires, Argentina",
		logo_url:
			"https://i.pinimg.com/564x/c0/e5/15/c0e515527077b382b5976bdd00ba42f9.jpg",
		cover_url:
			"https://images.unsplash.com/photo-1529241160658-a8a2a0d86620?q=80&w=3570&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
		web_url: "https://wa.me/c/5492346634188",
		ig_url:
			"https://instagram.com/san_francisco_fiambreria?igshid=kw7tjbairzse",
	},
	{
		name: "AEV Power Consulting",
		description: "Consutoria",
		type: "Establecimiento",
		address: "Pringles 1057, D5700 San Luis, Argentina",
		logo_url:
			"https://i.pinimg.com/564x/7a/e8/d9/7ae8d96624790d98378bcec83d4b2dbd.jpg",
		cover_url:
			"https://images.unsplash.com/photo-1589201529153-5297335c1684?q=80&w=3732&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
		web_url: "https://www.aevpower.com",
		ig_url: "https://www.instagram.com/aevpower_energias_renovables",
	},
	{
		name: "MKE Solutions",
		description: "Soporte IT",
		type: "Ecommerce",
		address: "Paraná 416, Rio Cuarto, Córdoba",
		logo_url: "/home/merchants/mke.png",
		cover_url: "/home/merchants/covers/mke_cover.png",
		web_url: "https://www.mkesolutions.net/",
		ig_url: "https://www.instagram.com/mkesolutions/",
	},
	{
		name: "Aire Molino",
		description: "Ropa",
		type: "Ecommerce",
		address: "Buenos Aires",
		logo_url:
			"https://acdn.mitiendanube.com/stores/108/769/themes/common/img-1618628248-1457580251-72a3b4f90642734e36b2d396e155f98a1512205677-480-0.webp",
		cover_url:
			"https://acdn.mitiendanube.com/stores/108/769/themes/new_linkedman/1-slide-1680214176325-3065881090-7c8afa4c58136831ef6dfb6c7687fd131680214206-1920-1920.webp?1438058526",
		web_url: "https://airemolino.com.ar/",
		ig_url: "https://www.instagram.com/airemolino/",
	},
	{
		name: "Kaiapuni",
		description: "Pruductos de diseño circular",
		type: "Ecommerce",
		address: "Chubut 1475, Pilar",
		logo_url:
			"https://acdn.mitiendanube.com/stores/001/879/776/themes/common/logo-106336687-1687423102-e47c9d94b8aca1146f9e15b43f22738d1687423103-320-0.webp",
		cover_url:
			"https://acdn.mitiendanube.com/stores/001/879/776/themes/rio/1-slide-1694445429681-7305358605-2fb93c8a8fc4e1c399ce0bf6f6b4e3fb1694445442-1920-1920.webp?1513102311",
		web_url: "https://www.kaiapuni.com.ar/",
		ig_url: "https://www.instagram.com/kaiapuni.arg/",
	},
	{
		name: "DanteHogar",
		description: "Iluminación & Deco",
		type: "Ecommerce",
		address: "Av.Avelino Rolon 1984, San Isidro",
		logo_url:
			"https://i.pinimg.com/564x/27/26/92/272692eab04c3b7ece1c50465aeb7743.jpg",
		cover_url:
			"https://acdn.mitiendanube.com/stores/001/280/240/products/img_08751-a47e8cfb9dc34a668716742441293905-1024-10241-a929c886d22631858916771672577258-1024-1024.webp",
		web_url: "https://danteiluminacion.com.ar/",
		ig_url: "https://www.instagram.com/dantehogar/",
	},
	{
		name: "Macadamias",
		description: "Objetos textiles",
		type: "Ecommerce",
		address: "Florida, Vicente López",
		logo_url:
			"https://i.pinimg.com/564x/91/65/d7/9165d73575b60ec276fcafb21152d642.jpg",
		cover_url:
			"https://acdn.mitiendanube.com/stores/536/710/themes/idea/2-slide-1700417434393-2269222062-ba2f44473c60d8a890ea0db9fff1265e1700417456-1920-1920.webp?213715966",
		web_url: "https://macadamias.com.ar/",
		ig_url: "https://www.instagram.com/macadamias/",
	},
	{
		name: "Moiso",
		web_url: "https://www.moiso.com.ar/",
		description: "Deco & Lights",
		type: "Ecommerce",
		logo_url:
			"https://i.pinimg.com/280x280_RS/99/05/fe/9905fe3323653231f71ee73f6c0eb0ae.jpg",
		cover_url:
			"https://acdn.mitiendanube.com/stores/433/020/products/a5fa8fa3-7a09-46b0-b2b3-49b74e2c2c2a1-b70cb1bfa96ff70a5d16789249140927-640-0.webp",
		ig_url: "https://www.instagram.com/moisodeco/",
		address: "Villa Pueyrredon",
	},
	{
		name: "Fluir",
		description: "Muebles para la infancia",
		type: "Ecommerce",
		ig_url: "https://www.instagram.com/fluirkids",
		web_url: "https://www.fluir.com.ar/",
		address: "Gualeguaychú, Entre Ríos",
		logo_url:
			"data:image/png;base64,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",
		cover_url:
			"https:////d3ugyf2ht6aenh.cloudfront.net/stores/543/450/themes/new_linkedman/1-slide-1572907393171-6265246159-6eb222199098806fef2c948bedf5cc931572907402-1024-1024.webp?156834578",
	},
	{
		name: "Guadalupe Ferreyra",
		description: "Joyeria",
		type: "Ecommerce",
		ig_url: "https://www.instagram.com/lupeferreyra/",
		web_url: "https://www.guadalupeferreyra.com.ar/",
		address: "Villa Urquiza, Buenos Aires",
		logo_url:
			"https://i.pinimg.com/564x/9c/bc/a2/9cbca21083fd6bc1e57f22cfa7268ac3.jpg",
		cover_url:
			"https://d22fxaf9t8d39k.cloudfront.net/596d5385c857b1d6bc1350b7a515db5892bd92c077722420ab7cf9b8843369b125562.jpg",
	},
	{
		name: "Relacha",
		description: "Deco & Hogar",
		type: "Ecommerce",
		ig_url: "https://www.instagram.com/relacha.deco/",
		web_url: "https://www.relacha.com.ar/",
		address: "Vidt 2181 piso 4, Palermo, CABA",
		logo_url:
			"https://acdn.mitiendanube.com/stores/001/319/756/themes/common/logo-1946408957-1667154565-11c4b0c6049c5371ffe257ebe6da9eb61667154566.ico?0",
		cover_url:
			"https://acdn.mitiendanube.com/stores/001/319/756/products/florero-jamaica-grande-3-web1-7b21ac484da42a073016867611455628-1024-1024.webp",
	},
	{
		name: "Sirnekoarg",
		description: "Especias y Hierbas Medicinales",
		type: "Ecommerce",
		ig_url: "https://www.instagram.com/sirnekoarg/",
		web_url: "https://sirneko.com.ar/",
		address: "Parque Patricios (CABA)",
		logo_url:
			"https://sirneko.com.ar/wp-content/uploads/2021/07/sir-neko-ml.png",
		cover_url:
			"https://sirneko.com.ar/wp-content/uploads/2023/10/image-980x653.png",
	},
]

const slicedMerchants = merchants.slice(0, 8)

const MarketplaceBox = () => {
	const isLg = useBreakpoint("lg")
	const navigate = useNavigate()
	return (
		<Col>
			<div className="flex w-full justify-between items-center py-4">
				<p className="text-h5 text-[#222] font-bold">Marcas recientes</p>
				<Button
					size="md"
					variant="outline"
					onClick={() => navigate("/marketplace")}
				>
					Ver mas
				</Button>
			</div>
			<div className="grid grid-cols-12 rounded-3xl border border-solid border-[#B9C8B9]">
				{slicedMerchants.map((merchant, index) => (
					<div
						key={merchant.name}
						className="col-span-12 lg:col-span-6 grid-flow-col items-center px-betweenComponents"
					>
						<MerchantRow {...merchant} />
						{((isLg && index < slicedMerchants.length - 1) ||
							(!isLg && index < slicedMerchants.length - 2)) && (
							<Separator className="bg-border w-11/12 lg:w-5/6 mx-auto" />
						)}
					</div>
				))}
			</div>
		</Col>
	)
}

export default MarketplaceBox
